import { useMemo, useState } from 'react'
import { capture, markDone } from '../api/client'
import { ItemCard, type ProjectTitles } from '../components/ItemCard'
import type { Item, State } from '../types'

interface Props {
  state: State | null
  onEdit: (item: Item) => void
  onReclarify: (id: string) => void
  onChanged: () => void
}

export default function Capture({ state, onEdit, onReclarify, onChanged }: Props) {
  const [title, setTitle] = useState('')
  const [busy, setBusy] = useState(false)

  const projectTitles: ProjectTitles = useMemo(() => {
    const map: ProjectTitles = {}
    for (const p of state?.projects ?? []) map[p.id] = p.title
    return map
  }, [state])

  async function send() {
    const t = title.trim()
    if (!t || busy) return
    setBusy(true)
    try {
      await capture(t)
      setTitle('')
      onChanged()
    } finally {
      setBusy(false)
    }
  }

  // Clore une capture sans la clarifier : elle est déjà faite, ouvrir le coach
  // pour ça ne servirait à rien.
  async function done(id: string) {
    if (busy) return
    setBusy(true)
    try {
      await markDone(id)
      onChanged()
    } finally {
      setBusy(false)
    }
  }

  const inbox = (state?.items ?? []).filter((i) => i.status === 'inbox')

  return (
    <>
      <div className="capture">
        <input
          placeholder="Une pensée, une tâche…"
          autoComplete="off"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && void send()}
        />
        <button onClick={() => void send()}>+</button>
      </div>
      <div className="hint">Entrée = capturé. C'est le seul endroit où tu tapes.</div>
      <div className="sec">Inbox ({inbox.length})</div>
      {inbox.length === 0 ? (
        <div className="empty">Inbox vide.</div>
      ) : (
        inbox.map((i) => (
          <ItemCard
            key={i.id}
            item={i}
            projects={projectTitles}
            onEdit={onEdit}
            onReclarify={onReclarify}
            onDone={(id) => void done(id)}
          />
        ))
      )}
    </>
  )
}
